import Beacon, { beaconSizeForPixels } from './Beacon.jsx';

// OGC-440: compatibility alias for the retired arc spinner. Renders the Beacon
// immediately (no delay) so surfaces that were not migrated — the paused
// creation progress modal keeps its own staged progress — behave as before.
export default function LoadingSpinner({
  className = '',
  label = '',
  size = 32,
  style = {},
  tone = 'brand',
}) {
  return (
    <Beacon
      size={beaconSizeForPixels(size)}
      tone={tone === 'neutral' ? 'neutral' : 'accent'}
      label={label}
      delayMs={0}
      slowAfterMs={null}
      className={className}
      style={style}
    />
  );
}
